import type { AxiosRequestConfig } from 'axios';

import { BaseClient } from '../../clients';
import { responseInterceptor } from '../../interceptors';
import { useRequestDefinition } from '../../providers';
import type { RequestConfig } from '../../types';
import { REQUEST } from '../../types';

export type NoaIntegrationRequestConfig = AxiosRequestConfig & RequestConfig;

export const defineNoaIntegrationClient = useRequestDefinition<
  BaseClient,
  AxiosRequestConfig,
  NoaIntegrationRequestConfig
>(({ interceptors }) => {
  interceptors.response.use(responseInterceptor.onFulfilled, responseInterceptor.onRejected);

  return {
    id: REQUEST.NOA_INTEGRATIONS,
    client: BaseClient,
    options: ({ baseURL, token }) => ({
      baseURL: baseURL || '',
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token instanceof Function ? token() : token}`,
        'DP-APP-NAME': 'noa-notes-hub-front-app',
      },
    }),
  };
});
